import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { departmentsOptionsConstant, currencyOptionsConstant, studyReportTypeConstant, studyReportSubTypeConstant, studyReportPatientConstant, documentOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { GridApi } from 'ag-grid-community';
import { AttachmentClassificationComponent } from 'src/app/common/attachment-classification/attachment-classification.component';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { UserService } from '../../../../services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { CommonService } from '../../../../services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-eap-study-reports-view-modal',
  templateUrl: './eap-study-reports-view-modal.component.html',
  styleUrls: ['./eap-study-reports-view-modal.component.scss']
})
export class EapStudyReportsViewModalComponent implements OnInit {

  formFields;
  departments = departmentsOptionsConstant;
  currencyOptions = currencyOptionsConstant;

  studyReportsForm: UntypedFormGroup;

  content: any;
  heading: string;
  action: Subject<any> = new Subject();

  formData: FormData;
  typeOptions: any[];
  subtypeOptions: any[];
  AllsubtypeOptions: any[];
  patientOptions: any[];
  documentOptions = documentOptionsConstant;
  gridApi: GridApi;
  rowData;
  context;
  ApplicationID: any;
  userType: string = "";
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public commonService: CommonService

  ) {
    
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.heading === 'Add') { //Add mode 
      this.content.id = this.commonService.getUniqueId();
    }
    this.userType = this.userService.getUserType();
    this.studyReportsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      TYPE: new UntypedFormControl(""),
      SUB_TYPE: new UntypedFormControl(""),
      PATIENT_ID: new UntypedFormControl(null),
      TITLE: new UntypedFormControl(""),
      NOTES: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(0)
    });
    this.GetDropDownsData();

   
 
  }
  GetDropDownsData() {
    this.summaryService.masterData("api/EAPStudyreports/GetMasterData?ApplicationID=" + this.ApplicationID +"&RecordID=" + this.content.id).subscribe(summary => {
      this.typeOptions = summary["MasterData1"];
      this.AllsubtypeOptions = summary["MasterData2"];
      this.patientOptions = summary["MasterData3"];
      if (this.heading === 'Edit' || this.heading === 'View') { // Edit mode
        this.getRecordFprEdit();
        if (this.heading === 'View') {
          this.studyReportsForm.disable();
        }
      }
    });
  }

  CategoryChange(data1) {
    debugger;
    this.subtypeOptions = [];
    var data = this.AllsubtypeOptions.filter(x => x.Parentvalue == data1);
    this.subtypeOptions = data;
  }

  deleteRow() {

  }

  editRow() {

  }


  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/EAPStudyreports/Edit?RecordID=" + this.content.id).subscribe(result => {
      this.studyReportsForm.patchValue({
        ID: result["ID"],
        APPLICATION_ID: result["APPLICATION_ID"],
        TITLE: result["TITLE"],
        NOTES: result["NOTES"],
        TYPE: result["TYPE"],
        SUB_TYPE: result["SUB_TYPE"],
        PATIENT_ID: result["PATIENT_ID"],
        STATUS: result["STATUS"],
      });
    
      if (this.heading === 'Edit' || this.heading === 'View') {
        this.CategoryChange(this.studyReportsForm.controls["TYPE"].value);
      }
      if (this.studyReportsForm.controls["STATUS"].value == '2') { // Edit mode
        this.studyReportsForm.disable();
        this.heading = "View";
      }
    });

  }
  SaveStudyReports() {
    debugger
    if (this.validateControls() && this.extendedForm.validateControls()) {
      debugger;
      var formData = this.studyReportsForm.value;
      formData["APPLICATION_ID"] = this.ApplicationID;
      formData["RECORD_STATE"] = 0;
      formData["CREATED_DATE"] = new Date();
      formData["LAST_UPDATED_DATE"] = new Date();

      if (this.heading == "Add") {
        formData["ID"] = this.content.id;
        this.summaryService.Insert("api/EAPStudyreports/Insert", formData).subscribe(result => {
          this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
            this.commonService.SuccessBanner('Data has been inserted successfully.' );
           // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });
            
            this.modalRef.close();
          });
          
        });
      }
      else {
        this.summaryService.Insert("api/EAPStudyreports/Update", formData).subscribe(result => {
          this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
            this.commonService.SuccessBanner('Data has been inserted successfully.');
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });
            
            this.modalRef.close();
          });
        });
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.studyReportsForm.value;
    if (formData.TYPE === null || formData.TYPE === "") {
      $("#TYPE").addClass("ng-touched ng-invalid validate-error");
      $("#TYPE").removeClass("ng-untouched ng-valid");
      message += "Please select Type.<br/>";
      isValid = false;
    } else {
      $("#TYPE").addClass("ng-untouched ng-valid");
      $("#TYPE").removeClass("ng-touched ng-invalid validate-error");
    }

    //if (formData.PATIENT_ID === null || formData.PATIENT_ID === "") {
    //  $("#PATIENT_ID").addClass("ng-touched ng-invalid validate-error");
    //  $("#PATIENT_ID").removeClass("ng-untouched ng-valid");
    //  message += "Please select Patient Name.<br/>";
    //  isValid = false;
    //} else {
    //  $("#PATIENT_ID").addClass("ng-untouched ng-valid");
    //  $("#PATIENT_ID").removeClass("ng-touched ng-invalid validate-error");
    //}

    if (formData.TITLE === null || formData.TITLE === "") {
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter Title.<br/>";
      isValid = false;
    } else {
      $("#TITLE").addClass("ng-untouched ng-valid");
      $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.NOTES === null || formData.NOTES === "") {
      $("#NOTES").addClass("ng-touched ng-invalid validate-error");
      $("#NOTES").removeClass("ng-untouched ng-valid");
      message += "Please enter Notes.<br/>";
      isValid = false;
    } else {
      $("#NOTES").addClass("ng-untouched ng-valid");
      $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
     this.commonService.ValidationBanner(message);
     // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }

  //SubmitRecord() {
  //  if (this.validateControls() && this.extendedForm.validateControls()) {
  //    var formData = this.studyReportsForm.value;
  //    formData["APPLICATION_ID"] = this.ApplicationID;
  //    formData["RECORD_STATE"] = 0;
  //    formData["CREATED_DATE"] = new Date();
  //    formData["LAST_UPDATED_DATE"] = new Date();
  //      this.summaryService.Insert("api/EAPStudyreports/Update", formData).subscribe(result => {
  //        this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
  //          this.summaryService.UpdateStatus("api/EAPStudyreports/UpdateStatus?RecordID=" + this.content.id).subscribe(result => {
  //            debugger;
  //            this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Record has been Submitted successfully.' } } });
  //            
  //            this.modalRef.hide();
  //          });
  //        });
  //      });
  //  }
  //}

  SubmitRecord() {
    debugger
    if (this.validateControls() && this.extendedForm.validateControls()) {
      debugger;
      var formData = this.studyReportsForm.value;
      formData["APPLICATION_ID"] = this.ApplicationID;
      formData["RECORD_STATE"] = 0;
      formData["CREATED_DATE"] = new Date();
      formData["LAST_UPDATED_DATE"] = new Date();
      formData["STATUS"] = 2;
      if (this.heading == "Add") {
        formData["ID"] = this.content.id;
        this.summaryService.Insert("api/EAPStudyreports/Insert", formData).subscribe(result => {
          this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
            this.commonService.ValidationBanner('Data has been inserted successfully.');
           // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });
            
            this.modalRef.close();
          });

        });
      }
      else {
        this.summaryService.Insert("api/EAPStudyreports/Update", formData).subscribe(result => {
          this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
            this.commonService.ValidationBanner('Data has been updated successfully.');
           // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been updated successfully.' } } });
            
            this.modalRef.close();
          });
        });
      }
    }
  }

}
